import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styles from "./QuoteHeaderNewBrand.module.css";
import AppContext from '../../store/app-context';
import AuthContext from '../../store/auth-context';

const QuoteHeader = (props) => {
    const appCtx = useContext(AppContext);
    const authCtx = useContext(AuthContext);

    let totalItem = 0;
    if(props && props.quote && props.quote.quoteLineEntityList && props.quote.quoteLineEntityList.length > 0){
        props.quote.quoteLineEntityList.forEach((item) => (
            totalItem = totalItem + parseInt(item.quantity)
        ));
    }

    let label_requestQuote = 'Quote Request';
    let label_quoteHistory = 'View Saved Quotes';
    let label_shoppingCart = 'Shopping Cart';

    if(appCtx && appCtx.bioradResources){
        label_requestQuote = appCtx.bioradResources.Quote_Cart ? appCtx.bioradResources.Quote_Cart : 'Quote Request';
        label_quoteHistory = appCtx.bioradResources.Quote_History ? appCtx.bioradResources.Quote_History : 'View Saved Quotes';
        label_shoppingCart = appCtx.bioradResources.Shopping_Cart ? appCtx.bioradResources.Shopping_Cart : 'Shopping Cart';
    }

    const cartURL = appCtx.envProp.appServer +
    "bc/" +
    appCtx.lang.toLowerCase() +
    "-" +
    appCtx.country.toLowerCase() +
    "/cart";

    return (
        <div className={styles.fullWidth}>
            <h1 className={styles.pageTitle}>{label_requestQuote}</h1>
            <div className={styles.header_view}>
                <div className={styles.quote_links}>
                    {authCtx.isLoggedIn && (
                        <Link to="/quotes">{label_quoteHistory}</Link> 
                    )}
                </div>
                <span><a href={cartURL} className={styles.btnlinkU} >{label_shoppingCart}</a></span>
            </div>
        </div>
    );
};

export default QuoteHeader;